<template>
      <div class="cardPaymentConfigCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'cardPaymentConfig', params: {} }">
          Card Payment Config
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'cardPaymentConfigCreate', params: {} }">
            Create Card Payment Config
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Card Payment Config</v-card-title>
          <v-card-text>
            <cardPaymentConfig-form></cardPaymentConfig-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import CardPaymentConfigForm from './CardPaymentConfigForm.vue';

    export default {
      name: 'cardPaymentConfig',
      components: {
        CardPaymentConfigForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    